let g_scroll = window.pageYOffset;

var cookiesSectionHeight = 0;
var searchbarSectionHeight = 0;
var headerPositionTop = 0;

if(typeof(document.querySelector('.header-section')) != 'undefined' && document.querySelector('.header-section') != null) {
    var headerHeight = document.querySelector('.header-section').offsetHeight;
}

if(typeof(document.querySelector('.searchbar-section')) != 'undefined' && document.querySelector('.searchbar-section') != null) {
    enableFixedHeader();

    // Update header on resize
    window.addEventListener('resize', function (event) {
        enableFixedHeader();
    });

    // Update header on scroll
    window.addEventListener('scroll', function (event) {
        enableFixedHeader();
    });
}

// Change margin/top on searchbar toggle
if(typeof(document.querySelector('.searchbar-section')) != 'undefined' && document.querySelector('.searchbar-section') != null) {
    document.querySelector('[data-toggle-element=".searchbar-section"]').addEventListener('click', function (e) {
        if (typeof (document.querySelector('.searchbar-section.invisible')) != 'undefined' && document.querySelector('.searchbar-section.invisible') != null) {
            searchbarSectionHeight = getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section.invisible').offsetHeight;
        } else {
            searchbarSectionHeight = 0;
        }

        cookiesSectionHeight = getPreviousSibling(document.querySelector('.header-section'), '.cookies-section').offsetHeight;
        headerPositionTop = cookiesSectionHeight + searchbarSectionHeight;

        // Set margin/top
        getNextSibling(document.querySelector('.header-section')).style.marginTop = headerHeight + 'px';
        document.querySelector('.header-section').style.top = headerPositionTop + 'px';

        if (g_scroll > cookiesSectionHeight) {
            getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section').classList.add('fixed');
            getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section').style.top = '0px';

            headerPositionTop = searchbarSectionHeight;
            document.querySelector('.header-section').classList.add('fixed');
            document.querySelector('.header-section').style.top = headerPositionTop + 'px';

        } else {
            getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section').classList.remove('fixed');
            getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section').style.top = cookiesSectionHeight + 'px';

            headerPositionTop = cookiesSectionHeight + searchbarSectionHeight;
            document.querySelector('.header-section').classList.remove('fixed');
            document.querySelector('.header-section').style.top = headerPositionTop + 'px';
        }
    });
}


// Set margin/top and fixed class
if(typeof(document.querySelector('.searchbar-section')) != 'undefined' && document.querySelector('.searchbar-section') != null) {
    function enableFixedHeader() {
        if (typeof (document.querySelector('.searchbar-section:not(.invisible)')) != 'undefined' && document.querySelector('.searchbar-section:not(.invisible)') != null) {
            searchbarSectionHeight = getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section:not(.invisible)').offsetHeight;
        } else {
            searchbarSectionHeight = 0;
        }

        cookiesSectionHeight = getPreviousSibling(document.querySelector('.header-section'), '.cookies-section').offsetHeight;
        headerPositionTop = cookiesSectionHeight + searchbarSectionHeight;
        headerHeight = document.querySelector('.header-section').offsetHeight;

        // Set margin/top
        getNextSibling(document.querySelector('.header-section')).style.marginTop = headerHeight + 'px';
        document.querySelector('.header-section').style.top = headerPositionTop + 'px';

        if (g_scroll > cookiesSectionHeight) {
            getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section').classList.add('fixed');
            getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section').style.top = '0px';

            headerPositionTop = searchbarSectionHeight;
            document.querySelector('.header-section').classList.add('fixed');
            document.querySelector('.header-section').style.top = headerPositionTop + 'px';

        } else {
            getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section').classList.remove('fixed');
            getPreviousSibling(document.querySelector('.header-section'), '.searchbar-section').style.top = cookiesSectionHeight + 'px';

            headerPositionTop = cookiesSectionHeight + searchbarSectionHeight;
            document.querySelector('.header-section').classList.remove('fixed');
            document.querySelector('.header-section').style.top = headerPositionTop + 'px';
        }
    }
}
